import React from "react";
import { Car, Bus, Truck, Bike, Construction } from "lucide-react";
import jcbimg from "../../Assets/Logos/jcb.png";
import busimg from "../../Assets/Logos/bus.png";
import truckimg from "../../Assets/Logos/truck.png";
import bikeimg from "../../Assets/Logos/motorcycle.png";
import scootyimg from "../../Assets/Logos/scooty.png";
import carimg from "../../Assets/Logos/car.png";

const Partners = () => {
  const vehicleIcons = [
    { img: scootyimg, name: "Scooters" },
    { img: bikeimg, name: "Bikes" },
    { img: carimg, name: "Cars" },
    { img: busimg, name: "Buses" },
    { img: truckimg, name: "Trucks" },
    { img: jcbimg, name: "JCBs" },
  ];

  return (
    <div className="w-full bg-gradient-to-r from-gray-50 via-white to-gray-50 py-6 px-4 md:px-10">
      <div className="w-full mx-auto">
        {/* Vehicle Icons Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center">
          {vehicleIcons.map((vehicle, index) => (
            <div
              key={index}
              className="group flex flex-col items-center p-6 rounded-xl bg-white"
            >
              <div className="mb-3 p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full group-hover:from-blue-100 group-hover:to-indigo-100 transition-colors duration-300">
                <img
                  src={vehicle.img}
                  alt=""
                  className="text-gray-600 group-hover:text-blue-600 transition-colors duration-300 h-20"
                />
              </div>
              <span className="text-md text-gray-700 group-hover:text-blue-600 transition-colors duration-300 font-semibold">
                {vehicle.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
